// frontend/src/services/storeService.ts
import api from './api';

export interface StoreStock {
  id: number;
  storeId: number;
  productCode: string;
  qrCodeValue?: string;
  inventoryType: string;
  quantity: number;
  updatedAt: string;
}

export interface Store {
  id: number;
  name: string;
  type: 'WAREHOUSE' | 'PHYSICAL' | 'ONLINE';
  address?: string;
  phone?: string;
  active: boolean;
  isVirtual: boolean;
  stocks: StoreStock[];
}

export interface CatalogueItem {
  id: string;
  cod_producto: string;
  name: string;
  precio: number;
  generalStock: number;
  qrCodeValue?: string;
  inventoryType: string;
}

export interface StoreTransferHistory {
  id: number;
  fromStoreId: number;
  toStoreId: number;
  productCode: string;
  productName: string;
  qrCodeValue?: string;
  inventoryType: string;
  quantity: number;
  status: string;
  notes?: string;
  createdAt: string;
  userId?: string;
  fromStore?: { name: string };
  toStore?: { name: string };
  user?: { nombre_completo?: string; username: string };
}

export class StoreService {
  async getStores(): Promise<{ stores: Store[]; catalogue: CatalogueItem[] }> {
    const response = await api.get('/stores');
    return response.data;
  }

  async createStore(data: { name: string; type?: string; address?: string; phone?: string; isVirtual?: boolean }): Promise<Store> {
    const response = await api.post('/stores', data);
    return response.data;
  }

  async updateStore(id: number, data: Partial<Store>): Promise<Store> {
    const response = await api.put(`/stores/${id}`, data);
    return response.data;
  }

  async transferInventory(data: {
    fromStoreId: number;
    toStoreId: number;
    productCode: string;
    qrCodeValue?: string;
    inventoryType: string;
    quantity: number;
    notes?: string;
  }): Promise<{ message: string; transfer: StoreTransferHistory }> {
    const response = await api.post('/stores/transfer', data);
    return response.data;
  }

  async getTransfers(): Promise<StoreTransferHistory[]> {
    const response = await api.get('/stores/transfers');
    return response.data;
  }
}

export const storeService = new StoreService();
export default storeService;
